import React from 'react';
import { FaRegCheckCircle } from 'react-icons/fa';

const FourthSection = () => {
    return (
        <>

            <div className="text-base-100 space-y-4">
                <div className='md:text-4xl font-bold text-center'>How to Buy Group Health Insurance</div>
                <p className='text-center'>Whether you are self-employed or have a workforce of up to 50 employees, you may qualify for group health insurance in most states.</p>

                <div className='flex'>
                    <FaRegCheckCircle className='mx-1 min-w-20 md:mx-2 mt-1 text-4xl text-secondary' />
                    <div>
                        <div className='text-xlfont-bold'>Self-Employed Group Health Insurance</div>
                        <p>Group health insurance for self-employed business owners is available in some states. If you may be eligible to get group health insurance with no employees. States that allow you to get group insurance for a small group of 1 do so on a guaranteed-issue basis. Therefore, you do not have to worry whether you qualify for coverage.</p>
                    </div>
                </div>

                <div className='flex'>
                    <FaRegCheckCircle className='mx-1 min-w-20 md:mx-2 mt-1 text-4xl text-secondary' />
                    <div>
                        <div className='text-xlfont-bold'>Group Health Insurance with Employees</div>
                        <p>If you hire at least one employee who is not a spouse, co-owner, business partner, or independent contractor, you can buy group health insurance through your Insurance Enterprise agent. There are a variety of insurance plans available for all types of small businesses and larger corporations with 50 or fewer employees.</p>
                    </div>
                </div>
            </div>

        </>
    );
}

export default FourthSection;
